import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const DraftOutline = createIcon({
  displayName: 'DraftOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M4,19.22222A1.77728,1.77728,0,0,0,5.77678,21h.001"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4,14.48444v1.77778"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18.22222,21A1.77728,1.77728,0,0,0,20,19.22322v-.001"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,16.26222V14.48444"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,8.5H16.5a2,2,0,0,1-2-2V3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20,11.52444V8.24264a3,3,0,0,0-.87868-2.12132L16.87868,3.87868A3,3,0,0,0,14.75736,3H7A3,3,0,0,0,4,6v5.52444"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.73778,21h1.77778"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.26222,21H13.48444"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const Draft: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={DraftTwoTone} {...props} />

  return <CustomIcon as={DraftOutline} {...props} />
}

export default memo(Draft)
